/**
 * Content-Security-Policy nonce plumbing.
 *
 * The server (UseSecurityPolicies) generates a per-request nonce, puts it in the
 * `Content-Security-Policy` header (`style-src-elem 'nonce-...'`) and substitutes it
 * into the `<meta property="csp-nonce">` tag of the SPA shell. Here we read it back and
 * hand it to the two things that inject <style>/<script> at runtime:
 *
 *   1. webpack  — via the magic `__webpack_nonce__` global, for async chunks and
 *                 (in dev) style-loader injected <style> tags.
 *   2. Emotion  — via a cache created with the nonce, so every MUI/@emotion style tag
 *                 (CssBaseline, GlobalStyles, styled(), the `sx` prop, ...) carries it.
 *
 * IMPORTANT: this module must be imported first in index.tsx so `__webpack_nonce__`
 * is set before any chunk is requested.
 */
import createCache from "@emotion/cache";

const nonce =
  document
    .querySelector('meta[property="csp-nonce"]')
    ?.getAttribute("content") || undefined;

// Tell webpack's runtime to stamp the nonce on tags it injects.
declare let __webpack_nonce__: string;
if (nonce) {
  __webpack_nonce__ = nonce;
}

export const cspNonce = nonce;

// `prepend: true` keeps MUI's styles first in <head> so application styles win.
export const emotionCache = createCache({
  key: "css",
  nonce,
  prepend: true,
});
